module.exports = __webpack_public_path__ + "img/17.28bbe366.jpg";